import React from 'react';
import './index.scss';

export default function AgroMapHoverCard({
  cursorX,
  cursorY,
  value,
  label,
  unit,
  stateName,
  formatValue = String,
}: {
  cursorX: number | null;
  cursorY: number | null;
  value: number | null;
  label: string;
  unit?: string;
  stateName: string | null;
  formatValue?: (v: number) => string;
}) {
  if (cursorX === null || cursorY === null || value === null) return null;

  return (
    <div
      className="agro-map-hover-card"
      style={{ left: cursorX + 14, top: cursorY - 56 }}
      role="status"
      aria-live="polite"
    >
      {stateName && (
        <div className="agro-map-hover-card__state">{stateName}</div>
      )}
      <div className="agro-map-hover-card__label">{label}</div>
      <div className="agro-map-hover-card__value">
        {formatValue(value)}
        {unit && <span className="agro-map-hover-card__unit">{` ${unit}`}</span>}
      </div>
    </div>
  );
}
